import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import CountertopGroup from "../../parts/countertopGroup";
import {LayoutAbbreviations, METADATA, useOldCabinetLogic} from "../../constants";

export default class BottomCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'bottom_cabinet';
    this.partName = 'Bottom Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.bottom_cabinet";
    this.hasAdditionalParts = true;
    this.layerPriority = 4;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    if (Array.isArray(dbFeature.metaData["MountType"]) && dbFeature.metaData["MountType"][0] === "0") {
      if (!dbFeature.metaData["MountType"].includes("FM")) {
        dbFeature.metaData["MountType"].push("FM")
      }
      if (!dbFeature.metaData["MountType"].includes("ST")) {
        dbFeature.metaData["MountType"].push("ST")
      }
    }
    if (dbFeature.metaData["RoomLayout"]
      && (dbFeature.metaData["RoomLayout"].includes("Layout3") || dbFeature.metaData["RoomLayout"].includes("3"))) {
      // на этом лаяуте синки с разным маунтайпом, а у bottom есть только один парт с маунтайпом S, U
      // т.е. тут можно вообще игнорить маунттайп и матчить все синки с боттом кабинетами
      dbFeature.metaData["MountType"] = METADATA.ALL
    }
    if (dbFeature.metaData["RoomLayout"]
      && (dbFeature.metaData["RoomLayout"].includes("Layout6") || dbFeature.metaData["RoomLayout"].includes("6"))) {
      if (!dbFeature.metaData["Stovetop"]) {
        dbFeature.metaData["Stovetop"] = METADATA.NO
      }
    }
    return super.load_(dbFeature, new BottomCabinet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const applianceParent = this.getParent().layout.parts[Appliance.id];
    if (applianceParent && applianceParent.stovetop) {
      applianceParent.stovetop.disabled = this.disabled
    }
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.bottomCabinet.activeFeature = this;
    }
    this.featureClicked();
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (useOldCabinetLogic) {
      return conditions
    }
    const cabinetParent = this.getParent();
    const countertopParent = cabinetParent.layout.parts[CountertopGroup.id];
    // const applianceParent = cabinetParent.layout.parts[Appliance.id];
    conditions.push({
      propName: "MountType",
      propValue: countertopParent && countertopParent.sink && countertopParent.sink.activeFeature
      && !countertopParent.sink.disabled && countertopParent.sink.featureGroupEnabled
        ? countertopParent.sink.activeFeature.metaData["MountType"]
        : ["U"]
    });
    return conditions
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "MountType"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const countertopParent = cabinetParent.layout.parts[CountertopGroup.id];
      const applianceParent = cabinetParent.layout.parts[Appliance.id];
      const sink = countertopParent.sink;

      //part 1 will be with MountType
      // part 2 dishwasher - depends on dishwasher metaData Width
      //part 3 depends on stove metaData Width // on Room Layout 6 we have Range + Stovetop, not Stove
      // part 4 - fridge
      // part 5 - peninsula

      let withStoveConditions = [...arrayOfConditions];
      if (applianceParent && applianceParent.layout.type === 6) {
        const rangeIsActive = applianceParent && applianceParent.range && !applianceParent.range.disabled && applianceParent.range.activeFeature;
        withStoveConditions.push({
          propName: "Stovetop",
          propValue: rangeIsActive ? METADATA.NO : "ST",
        });
        if (rangeIsActive && applianceParent.range.activeFeature.metaData["Width"]) {
          withStoveConditions.push({
            propName: "Width",
            propValue: applianceParent.range.activeFeature.metaData["Width"],
          })
        }
      } else {
        withStoveConditions.push({
          propName: "Width",
          propValue: applianceParent && applianceParent.stove && applianceParent.stove.activeFeature
          && applianceParent.stove.activeFeature.metaData["Width"]
            ? applianceParent.stove.activeFeature.metaData["Width"]
            : "30",
        })
      }
      // console.log("withStoveConditions", withStoveConditions);
      const withDishWasherConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.dishwasher && applianceParent.dishwasher.activeFeature
        && applianceParent.dishwasher.activeFeature.metaData["Width"]
          ? applianceParent.dishwasher.activeFeature.metaData["Width"]
          : "24",
      }];
      const withFridgeConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.fridge && applianceParent.fridge.activeFeature
        && applianceParent.fridge.activeFeature.metaData["Width"]
          ? applianceParent.fridge.activeFeature.metaData["Width"]
          : "36",
      }];
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (useOldCabinetLogic) {
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")
            && sink && !sink.disabled && sink.activeFeature) {
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([
              ...arrayOfConditions,
              {propName: "MountType", propValue: sink.activeFeature.metaData["MountType"]}
            ])
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")
            && applianceParent && applianceParent.dishwasher && !applianceParent.dishwasher.disabled && applianceParent.dishwasher.activeFeature) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")
            && applianceParent && applianceParent.stove && !applianceParent.stove.disabled && applianceParent.stove.activeFeature) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("6")) { // 6 is fridge related
            if (!applianceParent || !applianceParent.fridge || applianceParent.fridge.disabled || !applianceParent.fridge.activeFeature) {
              return false
            }
            const fridgeConditions = applianceParent.fridge.getFridgeWidthAndHeightConditions();
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([...arrayOfConditions, ...fridgeConditions])
          }
        } else {
          if (name1 !== feature.getSplittedFeatureName()) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
            return feature.matchesMetaForArrayOfConditions(withDishWasherConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
            return feature.matchesMetaForArrayOfConditions(withStoveConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")) {
            return feature.matchesMetaForArrayOfConditions(withFridgeConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("5")) {
            if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
              return false
            }
          }
          return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        }

        return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

}
